import React, { useState } from "react";
import { Stack } from "@mui/material";
import { useDispatch } from "react-redux";
import { Colors } from "../../../_app/types";
import { showNotification } from "../../../store/slices/notificationSlice";
import { HubError } from "../../../class/Error";
import { ButtonStyled } from "../../../_components/ButtonStyled";
import { useApi } from "../../../_hooks/use-api";
import Loading from "../../../_components/Loading";

interface Props {
  id: string;
  displayedId: string;
  onChange: (value: boolean) => void;
}

type CloseOptionAutoStrategy = "STOP_AND_CLOSE_POSITION" | "SIMPLE_STOP" | "FORCE_STOP";

const AutoStrategyClose = (props: Props) => {
  const dispatch = useDispatch();
  const api = useApi();

  const [loading, setLoading] = useState<Record<CloseOptionAutoStrategy, boolean>>({
    STOP_AND_CLOSE_POSITION: false,
    SIMPLE_STOP: false,
    FORCE_STOP: false,
  });

  const closeStrategy = async (closeOption: CloseOptionAutoStrategy) => {
    setLoading((prev) => ({ ...prev, [closeOption]: true }));
    try {
      await api.closeStrategy(props.id, closeOption);
      dispatch(
        showNotification({
          message: `Closing strategy ${props.displayedId}`,
          severity: "info",
        })
      );
    } catch (error: any) {
      error instanceof HubError
        ? dispatch(
            showNotification({
              message: `${error.message} ${error.detailedMessage}`,
              severity: "error",
            })
          )
        : dispatch(showNotification({ message: error.message, severity: "error" }));
    } finally {
      setLoading((prev) => ({ ...prev, [closeOption]: false }));
      props.onChange(false);
    }
  };

  const renderButton = (
    closeOption: CloseOptionAutoStrategy,
    label: string,
    style: React.CSSProperties
  ) => (
    <ButtonStyled
      style={{ fontWeight: 600, height: "40px", ...style }}
      fullWidth={true}
      variant="contained"
      onClick={() => closeStrategy(closeOption)}
    >
      {loading[closeOption] ? (
        <Loading color={"inherit"} size={20} />
      ) : (
        <div style={{ height: "20px" }}>{label}</div>
      )}
    </ButtonStyled>
  );

  return (
    <Stack sx={{ width: "100%" }} direction={"column"} spacing={1}>
      {renderButton("STOP_AND_CLOSE_POSITION", "Close orders and positions", {
        backgroundColor: Colors.Destructive,
      })}
      {renderButton("FORCE_STOP", "Force close", { backgroundColor: "#8F2D2D" })}
      {renderButton("SIMPLE_STOP", "Close orders", { backgroundColor: "#8F2D2D" })}

      <ButtonStyled
        style={{ fontWeight: 600, height: "40px" }}
        fullWidth={true}
        color={"primary"}
        variant="contained"
        onClick={() => props.onChange(false)}
      >
        Cancel
      </ButtonStyled>
    </Stack>
  );
};

export default AutoStrategyClose;
